"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:variable-name
exports.NullSerialiser = {
    read: function () { return null; },
    write: function () { }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/service-definition.js
// module id = 87
// module chunks = 1